<script>
  import { Modal } from 'bootstrap';
  import { onMount } from 'svelte';
  import { configItem } from './Helper';
  import FormTextarea from './FormControls/FormTextarea.svelte';
  import Loader from '../components/Loader.svelte';
  export let handleClick = (e) => {};
  let bulkComplianceStatus;
  let reason = '';
  let isLoading = false;
  onMount(() => {
    bulkComplianceStatus = new Modal(document.getElementById('changeComplianceStatusModal'), {
      keyboard: false,
    });
  });
  let taskParams = {
    selectedTasks: [],
  };
  let selectedValue;
  let showError = false;
  export const showModal = (params) => {
    isLoading = false;
    showError = false;
    selectedValue = null;
    taskParams = params;
    reason = '';
    bulkComplianceStatus.show();
  };
  let complianceTaskId;
  import Select from 'svelte-select';
</script>

<!-- Modal -->
<div
  class="modal fade"
  id="changeComplianceStatusModal"
  tabindex="-1"
  aria-labelledby="changeComplianceStatusModalLabel"
>
  <div class="modal-dialog">
    {#if isLoading}
      <div class="modal-content p-5 text-center">
        <div class="p-5">
          <Loader Style="loader-block" />
        </div>
      </div>
    {:else}
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title font-size-14 border-0"
            id="exampleModalLabel"
          >
            Change Compliance Status
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div
            class="form-group select-block select-client-type position-relative {showError
              ? 'error'
              : ''}"
          >
            <label
              for=""
              class="mb-3 color-lead">{taskParams?.selectedTasks?.length || 0} Tasks selected</label
            >
            <div class="form-group mb-3">
              <label
                for=""
                class="form-label">Select Compliance Status</label
              >
              <Select
                showChevron={true}
                isClearable={true}
                containerClasses="form-control"
                bind:selectedValue={selectedValue}
                placeholder="Select Compliance Status"
                items={configItem.allComplianceStatus}
                optionIdentifier="id"
                getSelectionLabel={(option) => option.name}
                getOptionLabel={(option) => option.name}
                on:select={(ev) => {
                  showError = false;
                  complianceTaskId = ev.detail.id;
                }}
              ></Select>
              {#if showError}
                <label
                  class="formError"
                  for="name">Please select compliance status</label
                >
              {/if}
            </div>
          </div>
          <div class="form-group">
            <FormTextarea
              label="Please tell us why you are making this change?"
              placeholder="Enter Notes (Optional)"
              name="updateReason"
              bind:value={reason}
              maxLength={configItem.maxLength.description}
              rows="6"
            />
          </div>
        </div>
        <div class="modal-footer border-0">
          <button
            type="button"
            class="trans-btn my-0 mx-3 px-4 font-size-12 outline-0 btn-cancel font-size-12"
            data-bs-dismiss="modal">Cancel</button
          >
          <button
            type="button"
            class="btn btn-primary m-0 px-4 font-size-12"
            on:click={() => {
              if (complianceTaskId > 0) {
                isLoading = true;
                showError = false;
                handleClick({ complianceTaskId, reason });
                bulkComplianceStatus.hide();
              } else {
                showError = true;
              }
            }}>Done</button
          >
        </div>
      </div>
    {/if}
  </div>
</div>
